import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./DishProductsListModal.module.css";
import DishProductModal from "../DishProductModal/DishProductModal";

const DishProductsListModal = () => {
  const { t } = useTranslation();
  const { dishProductsForModalArray } = useSelector(
    (store) => store.dishProducts
  );

  return (
    <section className={css.wrap}>
      {dishProductsForModalArray.length > 0 ? (
        dishProductsForModalArray.map((obj, index) => (
          <DishProductModal key={obj.name.en} dishProduct={obj} index={index} />
        ))
      ) : (
        <div className={css.noData}>{t("no-data")}</div>
      )}
    </section>
  );
};

export default React.memo(DishProductsListModal);
